import {HubConnection, HubConnectionBuilder, HubConnectionState} from "@microsoft/signalr";

import { ConfigurationProvider } from "../../../lib/infrastructure/configuration/ConfigurationProvider";
import { IdentityService } from "../../../lib/infrastructure/identity/IdentityService";
import { LogDTO } from "../../../common/models/LogDTO";

const Route = (path: string) => {
    return ConfigurationProvider.getConfiguration().App.BackendUrl + path;
};



export class RealtimeLogsEvent extends Event {
    logs: LogDTO[]; // Replace 'any' with the actual type of your logs data
  
    constructor(eventName: string, logs: LogDTO[]) {
      super(eventName);
      this.logs = logs;
    }
  }

export class RealtimeProvider {

    private static connection: HubConnection;

    // groups survive a reconnect only if we join them again (the server sees a new connection id)
    private static groups = new Set<string>();

    static init() {
        RealtimeProvider.connection = new HubConnectionBuilder()
        // the hub requires sign-in; WebSockets/SSE cannot carry headers, so SignalR sends this as ?access_token=
        .withUrl(Route("/realtime/logs"), {
            accessTokenFactory: async () => (await IdentityService.Global?.getAccessToken()) || "",
        })
        .withAutomaticReconnect()
        .build();

        RealtimeProvider.connection.onreconnected(() => {
            RealtimeProvider.groups.forEach((group) => RealtimeProvider.connection.send("joinGroup", group));
        });

        RealtimeProvider.connection.on(`SendLogs`, (logs: LogDTO[]) => {
            const event = new RealtimeLogsEvent('realtime-logsReceived', logs);
            console.log("SendLogs received",logs);
            window.dispatchEvent(event);
        });

        // Before sign-in the negotiate answers 401: that is fine, the first subscription starts it again.
        RealtimeProvider.ensureStarted().catch(() => undefined);

    }

    private static starting?: Promise<void>;

    private static ensureStarted(): Promise<void> {
        const connection = RealtimeProvider.connection;
        if (connection.state === HubConnectionState.Connected) return Promise.resolve();
        if (connection.state === HubConnectionState.Disconnected) {
            RealtimeProvider.starting = connection.start();
        }
        // Connecting: wait for that start; Reconnecting: onreconnected joins the groups again
        return RealtimeProvider.starting ?? Promise.resolve();
    }

    static subscribeGroup(groupName: string){
        RealtimeProvider.groups.add(groupName);
        RealtimeProvider.ensureStarted()
            .then(() => RealtimeProvider.connection.send("joinGroup", groupName))
            .catch((e) => console.error("Realtime logs: cannot connect", e));
    }

    static unSubscribeGroup(groupName: string){
        RealtimeProvider.groups.delete(groupName);
        RealtimeProvider.connection.send("removeGroup", groupName)
    }

}
